import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import logo from '../assets/logo.jpg';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { to: '/', label: 'Home', color: 'text-coral' },
    { to: '/services', label: 'Services', color: 'text-teal' },
    { to: '/about', label: 'About us', color: 'text-yellow' },
    { to: '/jobs', label: 'Join us', color: 'text-blue' },
    { to: '/contact', label: 'Contact', color: 'text-magenta' },
  ];

  return (
    <nav className="bg-darkBlue text-white shadow-xl sticky top-0 z-50 backdrop-blur-lg">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        {/* Logo & Tagline */}
        <div className="flex items-center gap-4">
          <Link to="/" className="flex items-center gap-4">
            <img src={logo} alt="MASA Hills Logo" className="h-14 w-auto rounded-md shadow-md" />
            <div>
              <h1 className="text-2xl font-bold font-heading tracking-wide">MASA HILLS</h1>
              <p className="italic text-sm text-yellow font-heading">Compassionate Home Health Services</p>
            </div>
          </Link>
        </div>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-6 text-base font-medium">
          {navLinks.map(({ to, label, color }) => (
            <Link
              key={to}
              to={to}
              className={`hover:${color} transition-colors duration-300`}
            >
              {label}
            </Link>
          ))}
          <a
            href="tel:+14695730176"
            className="ml-4 bg-coral px-6 py-2 rounded-full text-white hover:bg-[#e7683f] font-bold shadow transition-all duration-300"
          >
            Call Now
          </a>
        </div>

        {/* Hamburger */}
        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle Menu"
            className="p-2 rounded-md hover:bg-white/10 transition"
          >
            <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Animated Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            key="mobile-menu"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
            className="md:hidden px-6 pb-6 space-y-3 text-base font-medium bg-darkBlue/95 backdrop-blur-sm"
          >
            {navLinks.map(({ to, label, color }) => (
              <Link
                key={to}
                to={to}
                onClick={() => setIsOpen(false)}
                className={`block py-2 hover:${color} transition-colors duration-300`}
              >
                {label}
              </Link>
            ))}
            <a
              href="tel:1234567890"
              className="block w-full bg-coral px-6 py-3 rounded-full text-center text-white mt-4 font-bold shadow hover:bg-[#e7683f] transition-all duration-300"
            >
              Call Now
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
